import React, { useState } from "react";
import contentCopy from "../../../assets/icons/content_copy.svg";

export default function CopyToClipboard({ walletAddress }) {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(walletAddress);
      //   alert("Text copied to clipboard!");
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 2000);
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  };
  return (
    <div className="ml-1 w-3 relative  flex justify-end">
      <img onClick={handleCopy} src={contentCopy} alt="copy" />
      {isCopied && (
        <p className="absolute -top-12 bg-dark-secondary dark:text-dark-text text-sunny-text size-fit font-medium text-sm px-2 py-[0.051rem] rounded">
          Copied!
        </p>
      )}
    </div>
  );
}
